import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { Switch as BaseSwitch } from "@base-ui/react/switch";
import css from "./Switch.module.css";

const Switch = React.forwardRef(
  (
    {
      checked,
      defaultChecked,
      onCheckedChange,
      disabled = false,
      readOnly = false,
      required = false,
      name,
      value,
      label,
      description,
      className,
      ...rest
    },
    ref,
  ) => {
    const switchElement = (
      <BaseSwitch.Root
        ref={ref}
        className={css.root}
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        name={name}
        value={value}
        {...rest}
      >
        <BaseSwitch.Thumb className={css.thumb} />
      </BaseSwitch.Root>
    );

    if (!label) return switchElement;

    return (
      <label
        className={clsx(css.field, className)}
        data-disabled={disabled || undefined}
      >
        {switchElement}
        <div>
          <span className={css.label}>{label}</span>
          {description && <p className={css.description}>{description}</p>}
        </div>
      </label>
    );
  },
);

Switch.displayName = "Switch";

Switch.propTypes = {
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onCheckedChange: PropTypes.func,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  label: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default Switch;
